import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

// subject-profile.md's "Дата видачі:" formatting — ISO `yyyy-MM-dd` to `dd.MM.yyyy`.
export function formatUaDate(iso: string) {
  const [y, m, d] = iso.split("-")
  return `${d}.${m}.${y}`
}
